import { render, staticRenderFns } from "./InsightTripsTable.vue?vue&type=template&id=e2098704&scoped=true&"
import script from "./InsightTripsTable.vue?vue&type=script&lang=js&"
export * from "./InsightTripsTable.vue?vue&type=script&lang=js&"
import style0 from "./InsightTripsTable.vue?vue&type=style&index=0&id=e2098704&scoped=true&lang=css&"
import style1 from "./InsightTripsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2098704",
  null
  
)

export default component.exports